export default {
  reports: {
    // ---- AI report error codes (backend `errorCode`) -> localized messages ----
    errors: {
      INSUFFICIENT_CREDITS:
        "Vous n'avez pas assez de crédits IA pour générer ce rapport. Veuillez contacter votre administrateur.",
      REPORT_ACCESS_DENIED: "Ce rapport IA n'est pas activé pour votre compte.",
      NOT_FOUND: "Le rapport demandé est introuvable.",
      INVALID_INPUT: "Certaines informations fournies ne sont pas valides. Veuillez les vérifier et réessayer.",
      INVALID_GEOMETRY: "La zone sélectionnée n'est pas valide. Veuillez ajuster la géoclôture et réessayer.",
    },
    usersByStatus: "Utilisateurs par statut",
    usersByGender: "Utilisateurs par genre",
    gen: "Genre",
    gender: "Graphique du genre",
    male: "Homme",
    female: "Femme",
    other: "Autre",
    unspefied: "Non spécifié",
    byCountry: "Par pays",
    avgPriceFarmer: "Prix de vente moyen par tous les agriculteurs",
    avgPrice: "Prix de vente moyen par agriculteur",
    selectYear: "Sélectionner l'année",
    total: "Total",
    farmerName: "Nom de l'agriculteur",
    farmerProdChart: "Graphique de production de l'agriculteur",
    production: "Production",
    byProduction: "Par production",
    byName: "Par nom",
    descending: "Décroissant",
    ascending: "Croissant",
    buyingStationProdChart: "Graphique de production de la station d'achat",
    buyingStation: "Station d'achat",
    buyingStationName: "Nom de la station d'achat",
    dryMilling: "Broyage à sec",
    dryMillingName: "Nom du broyage à sec",
    dryMillingProdChart: "Graphique de production du broyage à sec",
    view: "Voir",
    date: "Date",
    reports: "Rapports",
    today: "Aujourd'hui",
    week: "Semaine",
    month: "Mois",
    year: "An",
    all: "Tout",
    selectCrop: "Sélectionner la culture",
    selectRegion: "Sélectionner la région",
    selectProvinceState: "Sélectionner la province/État",
    downloadPdfReport: "Télécharger le rapport PDF",
    export: "Exporter",
    search: "Rechercher",
    yield: "Rendement",
    avgAreaPerUnit: "Surface moyenne en {unit}",
    yieldPerUnit: "Rendement/{unit}",
    averageSellingPriceByAllFarmers: "Prix moyen de vente par tous les agriculteurs",
    averageSellingPricePerFarmer: "Prix moyen de vente par agriculteur",
    pricePaid: "Prix payé",
    pests: {
      pestReport: "Rapport sur les nuisibles",
      filterByCrops: "Filtrer par culture",
      pestStatistics: "Statistiques sur les nuisibles",
      regions: "Régions",
      occurrences: "Occurrences",
      pestChart: "Graphique des nuisibles",
      totalArea: "Surface totale",
      pestName: "Nom du nuisible",
      region: "Région",
      crop: "Cultures",
      listByLand: "Lister par terrain",
    },
    regions: {
      regionalReport: "Rapport régional",
      listByFarm: "Lister par ferme",
      listByFarmers: "Lister par agriculteurs",
      listByYield: "Lister par rendement",
      regionalStatistics: "Statistiques régionales",
      countries: "Pays",
      states: "États/Provinces",
      city: "Ville/Village",
      farmsIn: "Ferme(s) dans",
      regionalChart: "Graphique régional",
      farms: "Fermes",
      regionName: "Nom de la région",
      farmers: "Agriculteurs",
      yield: "Rendement/acre",
    },
    dashboard: {
      topCharts: "Graphiques principaux",
      regions: "Régions",
      noOfFarms: "Nombre de fermes/région",
      provinces: "Provinces/États",
      landArea: "Surface de terrain",
      avgFarmerLand: "Surface moyenne par agriculteur",
      viewAll: "Voir tout",
      crops: "Cultures",
      plantedAreaCrop: "Surface plantée par culture",
      plantedArea: "Surface plantée",
      avgYieldCrop: "Rendement moyen par culture",
      averageYield: "Rendement moyen",
      yieldChart: "Graphique de rendement",
      selectFarm: "Sélectionner la ferme",
      soilQuality: "Qualité du sol",
      pests: "Nuisibles",
      occurrences: "Occurrences",
      equipments: "Équipements",
      goalAchievedChart: "Graphique des objectifs atteints",
      soilValues: "Valeurs du sol",
      soil: "Sol",
      showReport: "Afficher les rapports sur le tableau de bord",
      selectAll: "Sélectionner tout",
    },
    weight: "Poids",
    quality: "Qualité",
    price: "Prix",

    yieldPrediction: "Prévision de Rendement",
    listOfReports: "Liste des Rapports",
    noYieldPredictionReportsFound: "Aucun rapport de prévision de rendement trouvé",
    loadingYieldPredictions: "Chargement des prévisions de rendement...",
    createNewReport: "Créer un Nouveau Rapport",

    howToUseReport: "Comment utiliser le rapport ?",
    viewGuide: "Voir le guide",
    cancel: "Annuler",
    generateReport: "Générer le Rapport",
    selectFarmGeofence: "Sélectionner la Géoclôture de la Ferme",
    selectFarmGeofenceDescription: "Sélectionnez une ferme enregistrée, dessinez la limite de votre ferme sur la carte ou saisissez un emplacement pour commencer à analyser la prévision de rendement de votre zone agricole.",
    point: "Point",
    geofence: "Géoclôture",
    selectFarmZone: "Sélectionner Ferme/Zone",
    select: "Sélectionner",
    latitude: "Latitude",
    longitude: "Longitude",
    uploadGeojsonFile: "Téléverser un Fichier GeoJSON",
    uploadGeojsonFileDescription: "Sélectionnez un fichier GeoJSON avec votre géoclôture depuis votre ordinateur et téléversez-le. Une seule géoclôture sera téléversée à la fois, même si votre fichier en contient plusieurs.",
    selectAFile: "Sélectionner un Fichier",
    hideAdvanced: "Masquer Avancé",
    showAdvancedVariation: "Afficher la Variation Avancée",
    uploadHistoricalYieldDataDescription: "Veuillez téléverser les données historiques de rendement de votre ferme",
    showInstructions: "Afficher les Instructions",
    downloadTemplate: "Télécharger le Modèle",
    chooseFile: "Choisir un Fichier",
    noFileSelected: "Aucun fichier sélectionné",
    yieldPredictionGuide: "Guide de Prévision de Rendement",
    forecastedYields: "Rendements Prévus",
    farmArea: "Surface de la Ferme",
    yieldForecasts: "Prévisions de Rendement",
    graph: "Graphique",
    actualYields: "Rendements Réels",
    predictedFutureYields: "Rendements Futurs Prévus",
    averageYields: "Rendements Moyens",
    yieldTrendsGraph: "Graphique des Tendances de Rendement",
    step1: "Étape 1",
    step2: "Étape 2",
    step3: "Étape 3",
    step4: "Étape 4",
    satelliteMapView: "Vue Satellite de la Carte",
    selectYourFarm: "Sélectionnez votre ferme dans le menu déroulant (si déjà enregistrée).",
    selectCropType: "Sélectionnez un type de culture :",
    clickGenerateReport: "Cliquez sur 'Générer le Rapport' pour voir votre rapport de prévision de rendement.",
    howToGenerateReport: "Comment Générer un Rapport ?",
    howToInterpretReport: "Comment Interpréter le Rapport ?",
    tip: "Astuce",

    disclaimer: "Avertissement",
    disclaimer1: "Il est impossible de prédire avec précision la météo pour une saison entière. Par exemple, la grêle ou les inondations peuvent survenir à tout moment, ce qui peut affecter considérablement les prévisions de rendement.",
    disclaimer2: "Les rendements dépendent fortement des pratiques de gestion de l'agriculteur. Par exemple, l'application opportune de pesticides ou une irrigation appropriée peut affecter considérablement le rendement final.",
    disclaimer3: "D'autres facteurs peuvent contribuer à des erreurs importantes dans les prévisions de rendement par IA.",
    startYear: "Année de Début",
    endYear: "Année de Fin",
    back: "Retour",
    deleteReport: "Supprimer le Rapport",
    confirmDeleteReport: "Êtes-vous sûr de vouloir supprimer ce rapport de prévision de rendement ? Cette action est irréversible et toutes les données associées seront définitivement supprimées.",
    deleteConfirmation: "Confirmation de Suppression",
    download: "Télécharger",
    report: "Rapport",
    dateOfReport: "Date du Rapport",
    farm: "Ferme",
    location: "Emplacement",
    zone: "Zone",
    crop: "Culture",
    farmers: "Agriculteurs",
    yieldPerAcre: "Rendement/Acre",
    yieldPerHectare: "Rendement/Hectare",
    predictionModel: "Modèle de Prévision",
    accuracy: "Précision (R²)",
    confidence: "Confiance",
    producer: "Producteur",
    reportDeletedSuccessfully: "Rapport supprimé avec succès",
    failedToDeleteReport: "Échec de la suppression du rapport",
    enterHere: "Entrez ici",
    hectares: "hectares",
    whatIsYieldReportTitle: "Qu'est-ce qu'un Rapport de Prévision de Rendement ?",
    yieldReportDescription: "Le Rapport de Prévision de Rendement vous aide à estimer les rendements des cultures de votre ferme en utilisant des données historiques, des données satellitaires et des modèles prédictifs basés sur l'IA. Le rapport vous donne une estimation de la récolte possible pour l'année en cours et les années à venir. Le rapport fournit des informations sur les rendements réels, les rendements futurs prévus et les rendements moyens, vous permettant d'optimiser vos opérations agricoles et de planifier à l'avance.",
    creatingYourReportEasy: "Créer votre rapport est facile :",
    selectYourFarmDescription: "La limite apparaîtra sur la carte. Sinon, dessinez manuellement la limite de votre ferme (polygone ou point) sur la carte si elle n'est pas encore enregistrée. Vous pouvez également rechercher en saisissant la latitude et la longitude pour zoomer sur un emplacement.",
    selectCropTypeDescription: "Choisissez la culture que vous souhaitez analyser dans le menu déroulant.",
    clickGenerateReportDescription: "pour afficher votre rapport de prévision de rendement.",
    interpretReportIntro: "Une fois le rapport généré, vous verrez les prévisions de rendement pour l'année en cours et l'année à venir. Un graphique affiche les tendances de rendement de votre ferme avec trois lignes :",
    blueLineActualYields: "Ligne Bleue (Rendements Réels) :",
    blueLineDescription: "Représente les résultats réels des récoltes des saisons précédentes sur votre ferme. Cela vous aide à comprendre les tendances de performance passées au fil du temps.",
    redLinePredictedYields: "Ligne Rouge (Rendements Futurs Prévus) :",
    redLineDescription: "Affiche les prévisions basées sur l'IA pour les futurs rendements. Elle fournit une estimation de ce à quoi vous pouvez vous attendre (combien vous pourriez récolter) en fonction des données et tendances actuelles.",
    brownLineAverageYields: "Ligne Brune (Rendements Moyens) :",
    brownLineDescription: "Indique le rendement moyen sur toutes les données disponibles pour la ferme. Cette ligne sert de référence pour vous aider à comparer les rendements historiques et prévus à la tendance globale.",
    highPredictedYieldsLabel: "Des rendements prévus élevés",
    highPredictedYieldsDescription: "suggèrent que les pratiques actuelles sont efficaces. Conservez vos stratégies, comme les reproduire dans d'autres zones de votre ferme.",
    lowPredictedYieldsLabel: "Des rendements prévus faibles",
    lowPredictedYieldsDescription: "peuvent indiquer des domaines à améliorer, tels que les calendriers de plantation, la santé du sol, l'utilisation d'engrais, l'irrigation, la gestion des ravageurs, le stress hydrique ou les carences nutritionnelles, etc. Étudiez et traitez ces problèmes tôt pour éviter de nouvelles pertes de rendement.",
    tipDescription: "Vous pouvez enregistrer, télécharger ou supprimer vos rapports pour référence future.",
    validationError: "Erreur de Validation",
    pleaseSelectCrop: "Veuillez sélectionner une culture",
    pleaseEnterLatLng: "Veuillez saisir la latitude et la longitude ou sélectionner un point sur la carte",
    pleaseDrawGeofence: "Veuillez dessiner une géoclôture sur la carte ou téléverser un fichier GeoJSON",
    invalidGeojsonFile: "Fichier GeoJSON invalide",
    invalidGeojsonFileDescription: "Veuillez vous assurer que le fichier est dans un format GeoJSON valide.",
    errorReadingFile: "Erreur de lecture du fichier",
    failedToReadGeojson: "Impossible de lire le fichier GeoJSON. Veuillez réessayer.",
    yieldReportGeneratedSuccessfully: "Rapport de prévision de rendement généré avec succès",
    failedToGenerateReport: "Échec de la génération du rapport. Veuillez réessayer.",
    farmAndFarmId: "Ferme et ID de la Ferme",
    producerName: "Nom du Producteur",
    failedToLoadReport: "Échec du chargement du rapport de prévision de rendement",
    reportDataNotLoaded: "Les données du rapport ne sont pas chargées. Veuillez patienter et réessayer.",
    pdfGeneratedSuccessfully: "PDF généré avec succès",
    failedToGeneratePdf: "Échec de la génération du PDF. Veuillez réessayer.",
    editMap: "Modifier la Carte",
    editMapDescription: "La fonctionnalité de modification de carte sera implémentée ici",
    noForecastDataAvailable: "Aucune donnée de prévision disponible",
    noGraphImageAvailable: "Aucune image de graphique disponible",
// Shared AI report redesign
    landSuitability: "Land Suitability",
    aiReportGuide: "AI Report Guide",
    aiReportsDashboard: "Tableau de bord des rapports IA",
    aiReports: "Rapports IA",
    dashboardGuide: "Guide du tableau de bord",
    aiReportBuilders: "Générateurs de rapports IA",
    aiInsightsAndAnalytics: "Insights et analyses IA",
    reportTypeDistribution: "Répartition par type de rapport",
    reportType: "Type de rapport",
    reportsGenerated: "Rapports générés",
    recentAiReports: "Rapports IA récents",
    vegetationVigorAnalysis: "Analyse de la vigueur végétative",
    farmProductivityAnalysis: "Analyse de productivité agricole",
    anomaliesDetection: "Détection d’anomalies",
    diseaseDetection: "Détection des maladies",
    averageVegetationHealth: "Santé végétative moyenne",
    diseaseDetectedThisMonth: "Maladies détectées ce mois-ci",
    anomaliesThisMonth: "Anomalies ce mois-ci",
    predictedYieldTrend: "Tendance de rendement prévue",
    comingSoon: "Bientôt disponible",
    reportBuilderComingSoon: "Ce générateur de rapports IA arrive bientôt.",
    loadingRecentReports: "Chargement des rapports récents…",
    noRecentAiReports: "Aucun rapport IA récent trouvé.",
    backToDashboard: "Back to dashboard",
    reportsBreadcrumb: "Reports",
    customizeTable: "Customize table",
    customization: "Customization",
    recordsPerPage: "Records per page",
    visibleColumns: "Visible columns",
    restoreDefault: "Restore default",
    apply: "Apply",
    reportId: "Report ID",
    viewReport: "View report",
    noLandSuitabilityReportsFound: "No Land Suitability reports found.",
    confirmDeleteLandSuitabilityReport: "Are you sure you want to delete this Land Suitability report?",
    landSuitabilityReportDeletedSuccessfully: "Land Suitability report deleted successfully.",
    unableToDeleteReport: "Unable to delete the report.",
    unableToDeleteReportRetry: "Unable to delete the report. Please try again.",
    of: "of",
    estimatedComputeCost: "Estimated Compute Cost",
    totalCreditsRequired: "Total Credits Required",
    creditsAvailable: "Credits Available",
    status: "Status",
    credits: "Credits",
    creditsSufficient: "Credits Sufficient for AI Report Generation",
    insufficientCredits: "Insufficient Credits",
    selectFarm: "Select Farm",
    showAdvanced: "Show advanced",
    drawingHintPoint: "Click the map to place a point. Drag the marker to adjust it.",
    drawingHintGeofence: "Click at least three locations to draw the geofence. Drag points to adjust it.",
    drawingHintPointShort: "Click the map to place or move the point",
    drawingHintGeofenceShort: "Click at least three locations to draw the farm boundary",
    undoLastGeofencePoint: "Undo last geofence point",
    undoLastPoint: "Undo last point",
    clearGeofence: "Clear geofence",
    previousImage: "Previous image",
    nextImage: "Next image",
    selectDate: "Select Date",
    reportDetails: "Report Details",
    greenAreas: "Green Areas",
    yellowAreas: "Yellow Areas",
    redAreas: "Red Areas",
    greenAreasDescription: "Current vegetation vigor outperforms historical average",
    yellowAreasDescription: "Current vegetation vigor performs according to historical average",
    redAreasDescription: "Areas with poor crop performance that require immediate attention",
    underperforming: "Underperforming",
    outperforming: "Outperforming",
    landSuitabilityDisclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, consult a qualified agronomist or agricultural expert.",
    startDate: "Start Date",
    numberOfHistoricalReports: "Number of Historical Reports",
    compareReports: "Compare reports",
    satelliteImageryNote: "Satellite imagery for the exact report date may not be available. The closest available satellite layer is shown instead.",
    farmLocation: "Farm location",
    feedback: "Feedback",
    feedbackColon: "Feedback:",
    agreedWithPrediction: "Agreed with Prediction",
    predictionNotAccurate: "Prediction Not Accurate",
    attachments: "Attachments",
    noAttachmentsAdded: "No attachments added",
    doYouAgreeWithPrediction: "Do you agree with the prediction?",
    agree: "Agree",
    disagree: "Disagree",
    agreeWithPrediction: "Agree with prediction",
    disagreeWithPrediction: "Disagree with prediction",
    feedbackDisagreementPlaceholder: "Tell us what does not reflect the current reality of the field",
    addAttachments: "Add attachments",
    removeAttachment: "Remove attachment",
    submitFeedback: "Submit feedback",
    loadingFeedback: "Loading feedback",
    attachment: "Attachment",
    unableToLoadAvailableCrops: "Unable to load available crops.",
    unableToGenerateReport: "Unable to generate the report.",
    unableToLoadLandSuitabilityReport: "Unable to load the Land Suitability report.",
    unableToDownloadReport: "Unable to download the report.",
    pleaseSelectValidGeojson: "Please select a valid Polygon or MultiPolygon GeoJSON file.",
    historicalComparisonUnavailable: "Historical comparison is not available from the current report API.",
    unableToLoadFeedback: "Unable to load feedback.",
    unableToLoadReportFeedback: "Unable to load report feedback.",
    attachmentTypeSizeLimit: "Attachments must be images or videos no larger than 10 MB.",
    unableToSubmitFeedback: "Unable to submit feedback.",
    feedbackSubmittedSuccessfully: "Feedback submitted successfully.",
    unableToSubmitFeedbackRetry: "Unable to submit feedback. Please try again.",
    openReportToViewGuide: "Open a report to view the complete AI report guide.",
    downloadReport: "Download report",
    pleaseSelectPointOnMap: "Please select a point on the map",
    pleaseDrawPolygonMinPoints: "Please draw a polygon with at least 3 points",
    // ---- Farm Productivity / Productivity Zones Analysis ----
    farmProductivity: {
      zoneLabels: {
        "Lowest Productivity Zones": "Zones de productivité la plus faible",
        "Low Productivity Zones": "Zones de faible productivité",
        "Moderate Productivity Zones": "Zones de productivité modérée",
        "High Productivity Zones": "Zones de productivité élevée",
        "Highest Productivity Zones": "Zones de productivité la plus élevée",
      },
      zoneDesc: {
        "Lowest Productivity Zones": "Zones avec les plus faibles performances des cultures nécessitant une attention ou une intervention immédiate.",
        "Low Productivity Zones": "Zones avec des performances des cultures inférieures à la moyenne nécessitant des améliorations.",
        "Moderate Productivity Zones": "Zones avec des performances modérées pouvant nécessiter quelques ajustements.",
        "High Productivity Zones": "Zones avec des performances supérieures à la moyenne et un bon potentiel de rendement.",
        "Highest Productivity Zones": "Zones avec des performances optimales et le plus grand potentiel de rendement.",
      },
    },
  },
}
